import { render, staticRenderFns } from "./StockDocument.vue?vue&type=template&id=dccb1aaa"
import script from "./StockDocument.vue?vue&type=script&lang=js"
export * from "./StockDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports